<template>
  <el-config-provider :locale="currentLocale">
    <router-view />
    <ReDialog />
  </el-config-provider>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { ElConfigProvider } from "element-plus"
import { ReDialog } from "@/components/ReDialog"
import zhCn from "element-plus/es/locale/lang/zh-cn"
import { useIdleTimeout } from "@/utils/idle-timeout"

export default defineComponent({
  name: "app",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
    ReDialog
  },
  setup() {
    // 启用全局空闲超时自动退出
    useIdleTimeout()
  },
  computed: {
    currentLocale() {
      return zhCn
    }
  }
})
</script>
